import * as THREE from 'three'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import { viewport, onResize } from './viewport.js'
import { params } from '../config/persistence.js'

export const createCamera = (canvas, scene) => {
    const camera = new THREE.PerspectiveCamera(35, viewport.width / viewport.height, 0.01, 100)
    camera.position.set(0, 0, 18)
    scene.add(camera)

    const controls = new OrbitControls(camera, canvas)
    controls.enableDamping = true
    controls.enableZoom = params.enableZoom
    controls.enablePan = params.enablePan
    controls.enableRotate = params.enableRotate
    controls.autoRotate = params.autoRotate
    controls.autoRotateSpeed = 3.7
    controls.minDistance = 6
    controls.maxDistance = 45

    onResize((vp) => {
        camera.aspect = vp.width / vp.height
        camera.updateProjectionMatrix()
    })

    return { camera, controls }
}
